import { CharactersheetsModel } from '@/model/charactersheets';

export const getters = {
  getGameSystem: (state: CharactersheetsModel) => {
    return state.gamesystem;
  },
  getProfile: (state: CharactersheetsModel) => {
    return state.profile;
  },
  getStatus: (state: CharactersheetsModel) => {
    return state.status;
  },
  getSkill: (state: CharactersheetsModel) => {
    return state.skill;
  },
  getOther: (state: CharactersheetsModel) => {
    return state.other;
  },
  getBackStory: (state: CharactersheetsModel) => {
    return state.backStory;
  },
  getUid: (state: CharactersheetsModel) => {
    return state.uid;
  },
  getPrivate: (state: CharactersheetsModel) => {
    return state.isPrivate;
  },
  getSkillList: (state: CharactersheetsModel) => {
    return state.skillList;
  },
  getJobPointFormula: (state: CharactersheetsModel) => {
    return state.jobPointFormula;
  },
};
